import {createReducer} from 'redux-act';
import {IArticleViewerContent} from '@app-types/article.types';
import {browseInArticleViewer, closeArticle, openArticle} from './article.actions';

export interface IArticleViewerState {
  content?: IArticleViewerContent;
}

// Deliberately excluded from redux-persist: a reader should never reopen after restarting the app.
const reducer = createReducer<IArticleViewerState>({}, {});
reducer
  .on(openArticle, (state, target) => ({
    content: {kind: 'article', value: target.reference, country: target.country},
  }))
  .on(browseInArticleViewer, (state, target) => ({
    content: {kind: 'browse', value: target.path, country: target.country},
  }))
  .on(closeArticle, () => ({}));

export default reducer;



// WEBPACK FOOTER //
// ./src/services/article/articleViewer.reducer.ts